import React, { useState } from 'react';
import styles from './create-category.module.scss';
import { DefaultButton, MiniInput } from 'shared/ui';
import { businessStore } from 'entities/index';
import { BookingApi } from 'shared/api';

interface ICreateCategoryProps {
  onClose?: () => void;
  onSuccess?: (message: string) => void;
}

export const CreateCategory: React.FC<ICreateCategoryProps> = ({
  onClose,
  onSuccess,
}) => {
  const pointId = businessStore.pointId;
  const [categoryName, setCategoryName] = useState<string>('');
  const [validationError, setValidationError] = useState('');
  const clearError = () => {
    setValidationError('');
  };

  const handleSubmit = async (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    try {
      if (pointId && categoryName) {
        BookingApi.createServiceCategory({
          category: categoryName,
          pointId: pointId,
        }).then(() => {
          businessStore.initServiceCategories(pointId);
          onSuccess?.('Категория успешно создана');
          onClose?.();
        });
        return;
      } else if (!categoryName) {
        setValidationError('Название категории не может быть пустым');
      }
    } catch (error) {
      if (error instanceof Error) {
        setValidationError(error.message);
      }
    }
    e.stopPropagation();
  };
  return (
    <div
      className={styles.create_category__container}
      onClick={(e) => {
        if ((e.target as HTMLElement).closest(`.${styles.buttons__button}`)) {
          handleSubmit(e);
          return;
        }
        e.stopPropagation();
      }}
    >
      <div className={styles.container__title}>Создание Категории</div>
      <div className={styles.container__inputs}>
        <div className={styles.inputs__input} onClick={clearError}>
          <MiniInput
            placeholder="Название категории"
            inputTitle="Название"
            inputValue={categoryName}
            onChange={(value) => setCategoryName(value)}
          />
        </div>
      </div>
      <div className={styles.content__error}>{validationError}</div>

      <div className={styles.container__buttons}>
        <div className={styles.buttons__button}>
          <DefaultButton
            buttonText="Создать"
            className={styles.button_create}
            color="green"
          />
        </div>
      </div>
    </div>
  );
};
